import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { ArrowRight, Package, Truck, Sparkles, CheckCircle2 } from "lucide-react";

const HowItWorks = () => (
  <div className="min-h-screen bg-background">
    <Navbar />
    <main className="container-page py-16">
      <div className="tiny-label mb-3">Jak to funguje</div>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900 max-w-3xl">
        Od špinavého koše ke <span className="text-sky-600">složené hromádce v 4 krocích.</span>
      </h1>

      <ol className="mt-12 space-y-5 max-w-3xl">
        {[
          { icon: Package, title: "Vyplníte objednávku", desc: "Vyberete kilogramy, typ služby, termín. Fotku pytle můžete přiložit pro lepší přípravu." },
          { icon: Truck, title: "Prádelna v okolí přijede", desc: "Po přijetí objednávky se objeví kontakt na prádelnu. Vyzvedne prádlo a vyfotí pro fotodokumentaci." },
          { icon: Sparkles, title: "Praní podle vašich preferencí", desc: "Eco, hypoalergenní, bez aviváže – stačí zaškrtnout." },
          { icon: CheckCircle2, title: "Doručeno a potvrzeno", desc: "Čisté složené prádlo zpět do bytu, vy potvrdíte přijetí a získáte věrnostní body." },
        ].map((s, i) => (
          <Card key={i} className="p-7 flex items-start gap-5">
            <div className="w-12 h-12 rounded-xl bg-sky-100 text-sky-700 grid place-items-center flex-shrink-0">
              <s.icon className="w-6 h-6" />
            </div>
            <div>
              <div className="text-xs text-sky-700 font-semibold">KROK {i + 1}</div>
              <h3 className="font-display text-xl font-bold mt-0.5">{s.title}</h3>
              <p className="text-slate-600 mt-1">{s.desc}</p>
            </div>
          </Card>
        ))}
      </ol>

      <div className="mt-12">
        <Link to="/registrace?role=customer" className="cta-primary">Vyzkoušet zdarma <ArrowRight className="w-4 h-4" /></Link>
      </div>
    </main>
    <Footer />
  </div>
);

export default HowItWorks;
